const v = {
  host: "",
  basePath: "/api/v1.0",
  authToken: ""
};
function i(o) {
  return {
    get: async (r = {}) => await D(o, "GET", {}, r),
    post: async (r = {}, a = {}) => await D(o, "POST", r, a),
    put: async (r = {}, a = {}) => await D(o, "PUT", r, a),
    patch: async (r = {}, a = {}) => await D(o, "PATCH", r, a),
    head: async (r = {}) => await D(o, "HEAD", {}, r),
    del: async (r = {}, a = {}) => await D(o, "DELETE", r, a)
  };
}
async function D(o, c, n = {}, t = {}) {
  return new Promise(async (e, u) => {
    const s = await fetch(o, {
      method: c,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${v.authToken}`,
        ...t
      },
      body: c === "GET" ? void 0 : JSON.stringify(n)
    }).catch((r) => {
      u(r);
    });
    if (!s)
      return u("No response");
    if (!s.ok)
      return u(s);
    try {
      const r = await s.json();
      e(r);
    } catch {
      e(!0);
    }
  });
}
function W(o, c, n) {
  const t = `${o}${c}/${n}/account`;
  function e() {
    return i(t).get();
  }
  return { get: e };
}
function N(o, c, n) {
  const t = `${o}${c}/${n}`;
  function e() {
    return i(t).get();
  }
  return { get: e };
}
function O(o, c) {
  const n = `${o}${c}/domains`;
  function t() {
    return i(n).get();
  }
  return { get: t };
}
function m(o, c, n) {
  const t = `${o}${c}/${n}/members`;
  function e() {
    return i(t).get();
  }
  function u(a) {
    return i(t).post(a);
  }
  function s(a) {
    return i(t).del(a);
  }
  function r() {
    return i(t + "/refresh").post();
  }
  return { get: e, post: u, del: s, refresh: r };
}
function L(o, c, n) {
  const t = `${o}${c}/${n}/searchUsers`;
  function e(u) {
    return i(`${t}?query=${u}`).get();
  }
  return { get: e };
}
function B(o, c, n, t) {
  const e = `${o}${c}/${n}/graph/${t}`;
  function u() {
    return i(e).get();
  }
  function s(r) {
    return i(e).patch(r);
  }
  return { get: u, patch: s };
}
function G(o, c, n, t) {
  const e = `${o}${c}/${n}/instance/${t}/nodePositions`;
  function u() {
    return i(e).get();
  }
  function s(r) {
    return i(e).put({ positions: r });
  }
  return { get: u, put: s };
}
function M(o, c, n, t) {
  const e = `${o}${c}/${n}/reasoning/${t}`;
  function u(s) {
    return i(e).post(s);
  }
  return { post: u };
}
function J(o, c, n) {
  const t = `${o}${c}/${n}/dataspaces`;
  function e() {
    return i(t).get();
  }
  function u(r, a, b, g) {
    return i(t).post({ templateId: r, version: a, name: b, description: g });
  }
  function s() {
    return i(t + "/registeredDataspaces").get();
  }
  return { get: e, post: u, getRegisteredDataspaces: s };
}
function R(o, c, n, t) {
  const e = `${o}${c}/${n}/dataspace/${t}`;
  function u() {
    return i(e).get();
  }
  function s(g) {
    return i(e).put(g);
  }
  function r() {
    return i(e).del();
  }
  function a() {
    return i(e + "/registerMongoDB").post();
  }
  function b() {
    return i(e + "/unregisterMongoDB").post();
  }
  return { get: u, put: s, del: r, registerMongoDB: a, unregisterMongoDB: b };
}
function U(o, c, n) {
  const t = `${o}${c}/${n}/workspaces`;
  function e() {
    return i(t).get();
  }
  function u(s, r, a, b, g) {
    return i(t).post({ dataspaceId: s, templateId: r, name: a, description: b, newId: g });
  }
  return { get: e, post: u };
}
function x(o, c, n, t) {
  const e = `${o}${c}/${n}/workspace/${t}`;
  function u() {
    return i(e).get();
  }
  function s(a) {
    return i(e).put(a);
  }
  function r() {
    return i(e).del();
  }
  return { get: u, put: s, del: r };
}
function V(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/dataobjects`;
  function u(a) {
    return i(e).post(a);
  }
  function s(a) {
    return i(e + "/search").post(a);
  }
  function r(a) {
    return i(e + "/import").post(a);
  }
  return { post: u, search: s, importExisting: r };
}
function C(o, c, n, t, e) {
  const u = `${o}${c}/${n}/${t}/dataobject/${e}`;
  function s() {
    return i(u).del();
  }
  return { del: s };
}
function H(o, c, n, t, e) {
  const u = `${o}${c}/${n}/${t}/notification/${e}`;
  function s() {
    return i(u).del();
  }
  return { del: s };
}
function q(o, c, n, t, e) {
  const u = `${o}${c}/${n}/${t}/attribute/${e}`;
  function s(r, a) {
    return i(u).put({ value: r, instanceTaskId: a });
  }
  return { put: s };
}
function z(o, c, n, t, e) {
  const u = `${o}${c}/${n}/${t}/task/${e}`;
  function s(r) {
    return i(u).put({ value: r });
  }
  return { put: s };
}
function F(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/workspaceDescriptors`;
  function u() {
    return i(e).get();
  }
  function s(a, b, g) {
    return i(e).post({ workspaceId: a, label: b, description: g });
  }
  function r(a) {
    return i(e).del({ workspaceId: a });
  }
  return { get: u, post: s, del: r };
}
function K(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/env`;
  function u(r) {
    const a = r != null && r.mask ? "?mask=true" : "";
    return i(`${e}${a}`).get();
  }
  function s(r) {
    return i(`${e}`).post(r);
  }
  return { getEnvironmentVariables: u, setEnvironmentVariables: s };
}
function Q(o, c, n, t) {
  const e = `${o}${c}/${n}/dataspaces/permissions`;
  function u() {
    return i(e + `/${t}`).get();
  }
  function s(g) {
    return i(e + `/${t}/add`).post({ userId: g });
  }
  function r(g) {
    return i(e + `/${t}/remove`).post({ userId: g });
  }
  function a() {
    return i(e + `/${t}/allow-all`).get();
  }
  function b(g) {
    return i(e + `/${t}/allow-all`).put({ allowAll: g });
  }
  return { get: u, add: s, remove: r, getAllowAll: a, setAllowAll: b };
}
function X(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/suggestions`;
  function u(r) {
    return i(e).put(r);
  }
  function s(r) {
    return i(e).post(r);
  }
  return { provide: u, accept: s };
}
function Y(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/newAlternisWorkspaces`;
  function u() {
    return i(e).get();
  }
  function s(r) {
    return i(e).post({ workspaceId: t, sessionId: r });
  }
  return { check: u, add: s };
}
function Z(o, c, n, t) {
  const e = `${o}${c}/${n}/${t}/alternis`;
  function u(h, k, P) {
    return i(`${e}/create-session-with-rtp`).post({
      label: h,
      reference: k,
      language: P
    });
  }
  function s() {
    return i(`${e}/end-session`).post({});
  }
  function r(h, k = {}) {
    return i(`${e}/message`).post({
      text: h,
      options: {
        sender: k.sender,
        emitImmediately: k.emitImmediately,
        useNovaVoice: k.useNovaVoice,
        language: k.language
      }
    });
  }
  function a(h) {
    return i(`${e}/emit-synthesis`).post({ messageId: h });
  }
  function b(h) {
    return i(`${e}/prefabs`).post({ prefabId: h });
  }
  function g(h, k) {
    return i(`${e}/rtp-language`).post({ role: h, language: k });
  }
  return { createSessionWithRtp: u, endSession: s, sendTextMessage: r, emitTranslationSynthesis: a, emitPrefab: b, postRtpLanguage: g };
}
function _(o, c, n, t, e) {
  const u = `${o}${c}/${n}/${e}/voiceBot`;
  function s() {
    return i(`${u}/create`).post({ dataspaceId: t });
  }
  function r() {
    return i(`${u}/exists`).get();
  }
  return { create: s, exists: r };
}
function w(o, c, n) {
  const t = `${o}${c}/${n}/model-graph`;
  function e() {
    return i(t).get();
  }
  return { get: e };
}
function d(o, c, n) {
  S(o, () => {
    o.send(
      JSON.stringify({
        type: "send",
        topic: c,
        payload: n
      })
    );
  });
}
function p(o, c) {
  S(o, () => {
    o.send(
      JSON.stringify({
        type: "subscribe",
        topic: c
      })
    );
  });
}
function l(o, c) {
  S(o, () => {
    o.send(
      JSON.stringify({
        type: "unsubscribe",
        topic: c
      })
    );
  });
}
function S(o, c) {
  if (o.readyState != WebSocket.OPEN) {
    const n = () => {
      o.removeEventListener("open", n), c();
    };
    o.addEventListener("open", n);
  } else
    c();
}
function I(o, c) {
  const n = "/domains";
  function t(u) {
    p(o, n), c[n] = u;
  }
  function e() {
    l(o, n), delete c[n];
  }
  return { on: t, off: e };
}
function tt(o, c, n) {
  const t = `/${c}`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function nt(o, c, n, t) {
  const e = `/${c}/${n}/graph`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function et(o, c, n) {
  const t = `/${c}/template/dataspaces`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function ot(o, c, n, t) {
  const e = `/${c}/template/dataspaces/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function ct(o, c, n) {
  const t = `/${c}/template/workspaces`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function ut(o, c, n, t) {
  const e = `/${c}/template/workspaces/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function st(o, c, n) {
  const t = `/${c}/instance/dataspaces`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function rt(o, c, n, t) {
  const e = `/${c}/instance/dataspace/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function it(o, c, n) {
  const t = `/${c}/instance/workspaces`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function at(o, c, n, t) {
  const e = `/${c}/instance/workspace/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function ft(o, c, n) {
  const t = `/${c}/instance/attributes`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function $t(o, c, n, t) {
  const e = `/${c}/instance/attribute/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function pt(o, c, n) {
  const t = `/${c}/instance/dataobjects`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function lt(o, c, n, t) {
  const e = `/${c}/instance/dataobject/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function gt(o, c, n) {
  const t = `/${c}/instance/tasks`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function bt(o, c, n, t) {
  const e = `/${c}/instance/task/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function ht(o, c, n) {
  const t = `/${c}/instance/processes`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function kt(o, c, n, t) {
  const e = `/${c}/instance/process/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function Dt(o, c, n) {
  const t = `/${c}/instance/events`;
  function e(s) {
    p(o, t), n[t] = s;
  }
  function u() {
    l(o, t), delete n[t];
  }
  return { on: e, off: u };
}
function vt(o, c, n, t) {
  const e = `/${c}/instance/event/${n}`;
  function u(r) {
    p(o, e), t[e] = r;
  }
  function s() {
    l(o, e), delete t[e];
  }
  return { on: u, off: s };
}
function yt(o, c, n, t) {
  const e = `/${c}/instance/${n}/dataobjectLivePosition`;
  function u(a) {
    d(o, e, a);
  }
  function s(a) {
    p(o, e), t[e] = a;
  }
  function r() {
    l(o, e), delete t[e];
  }
  return { send: u, on: s, off: r };
}
let f;
const $ = {};
let E;
const j = [];
let y = !1;
function A(o, c) {
  f || (f = new WebSocket(`${o}${c}`)), f.onopen = () => {
    y && (y = !1, j.forEach((n) => n())), setTimeout(() => Object.keys($).forEach((n) => p(f, n)), 100), E = setInterval(() => {
      f.readyState === WebSocket.OPEN && f.send(JSON.stringify({ type: "keepalive" }));
    }, 1e4);
  }, f.onclose = () => {
    clearInterval(E), y = !0, setTimeout(() => {
      f = new WebSocket(`${o}${c}`), A(o, c);
    }, 1e3);
  }, f.onmessage = (n) => {
    var s;
    const t = JSON.parse(n.data), e = t.topic, u = t.payload;
    (s = $[e]) == null || s.call($, u);
  };
}
function Tt(o, c) {
  return f || (f = new WebSocket(`${o}${c}`)), A(o, c), {
    ws: f,
    onDisconnect: (n) => {
      f.addEventListener("close", n);
    },
    onReconnect: (n) => {
      j.push(n);
    },
    domains: () => I(f, $),
    domain: (n) => ({
      ...tt(f, n, $),
      graph: (t) => nt(f, n, t, $),
      concept: () => ({}),
      template: () => ({
        dataspaces: () => et(f, n, $),
        dataspace: (t) => ot(f, n, t, $),
        workspaces: () => ct(f, n, $),
        workspace: (t) => ut(f, n, t, $)
      }),
      instance: () => ({
        dataspaces: () => st(f, n, $),
        dataspace: (t) => rt(f, n, t, $),
        workspaces: () => it(f, n, $),
        workspace: (t) => ({
          ...at(f, n, t, $),
          livePosition: () => yt(f, n, t, $)
        }),
        attributes: () => ft(f, n, $),
        attribute: (t) => $t(f, n, t, $),
        dataobjects: () => pt(f, n, $),
        dataobject: (t) => lt(f, n, t, $),
        tasks: () => gt(f, n, $),
        task: (t) => bt(f, n, t, $),
        processes: () => ht(f, n, $),
        process: (t) => kt(f, n, t, $),
        events: () => Dt(f, n, $),
        event: (t) => vt(f, n, t, $)
      })
    })
  };
}
function St(o, c, n, t) {
  const e = `${o}${c}/${n}/instance/${t}/logs`;
  function u() {
    return i(e).get();
  }
  return { get: u };
}
function Et(o, c, n) {
  const t = `${o}${c}/${n}/instance/stats`;
  function e() {
    return i(t).get();
  }
  return { get: e };
}
function jt(o, c) {
  const n = `${o}${c}/beta/kinasDataspaceId`;
  function t() {
    return i(n).get();
  }
  return { get: t };
}
function At(o, c) {
  const n = `${o}${c}/gpt`;
  function t(e) {
    return i(n).post(e);
  }
  return { post: t };
}
function Pt(o, c) {
  const n = `${o}${c}/deepl`;
  function t(e) {
    return i(n).post(e);
  }
  return { post: t };
}
let T;
function Wt(o = {}) {
  if (!T) {
    const t = new URL(v.host || window.location.href), u = `${t.protocol == "http:" ? "ws" : "wss"}://${t.host}`;
    T = Tt(u, "/api/v1.0");
  }
  const c = o.host || v.host, n = o.host || v.basePath;
  return {
    socket: () => T,
    domains: () => O(c, n),
    domain: (t) => ({
      ...N(c, n, t),
      account: () => W(c, n, t),
      searchUsers: () => L(c, n, t),
      members: () => m(c, n, t),
      modelGraph: () => w(c, n, t),
      graphs: (e) => B(c, n, t, e),
      dataspaces: () => J(c, n, t),
      dataspace: (e) => ({
        ...R(c, n, t, e),
        workspaceDescriptors: () => F(c, n, t, e),
        environment: () => K(c, n, t, e),
        permissions: () => Q(c, n, t, e)
      }),
      workspaces: () => ({
        ...U(c, n, t),
        stats: () => Et(c, n, t)
      }),
      workspace: (e) => ({
        ...x(c, n, t, e),
        positions: () => G(c, n, t, e),
        dataobjects: () => V(c, n, t, e),
        dataobject: (u) => C(c, n, t, e, u),
        attribute: (u) => q(c, n, t, e, u),
        task: (u) => z(c, n, t, e, u),
        notification: (u) => H(c, n, t, e, u),
        reasoning: () => M(c, n, t, e),
        suggestions: () => X(c, n, t, e),
        logs: () => St(c, n, t, e),
        newAlternisWorkspaces: () => Y(c, n, t, e),
        alternis: () => Z(c, n, t, e),
        voiceBot: (u) => _(c, n, t, u, e)
      })
    }),
    beta: () => ({
      kinasDataspaceId: () => jt(c, n)
    }),
    gpt: () => At(c, n),
    deepl: () => Pt(c, n)
  };
}
export {
  Wt as api,
  v as apiConfig
};
